import React, { Component } from 'react';
import { FormattedMessage, injectIntl  } from 'react-intl';
import { Col, Row, TabContent, TabPane } from 'reactstrap';
import BlockUi from 'react-block-ui';
import PaymentManagementMenu from './PaymentManagementMenu';
import Shift4Charges from './Shift4Charges';
import moment from 'moment';
import Shift4Payouts from './Shift4Payouts';
import Shift4Events from './Shift4Events';
import Shift4Customers from './Shift4Customers';
import Shift4PaymentLinks from './Shift4PaymentLinks';


class PaymentManagement extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: [],
            block: false,
            activeTab: 'Charges',
            startDate: moment().subtract(1, 'month'),
            endDate: moment(),
            chargeStatus: [
                { value: 'successful', label: this.props.intl.formatMessage({ id: "PaymentManagement.Successful" }), color: 'success' },
                { value: 'pending', label: this.props.intl.formatMessage({ id: "PaymentManagement.Pending" }), color: 'warning' },
                { value: 'failed', label: this.props.intl.formatMessage({ id: "PaymentManagement.Failed" }), color: 'danger' }
            ]
        }
    }

    componentDidMount() {
    }

    toggleMenu = (tab) => {
        this.setState({
            activeTab: tab
        })
    }

    handleDates = ({ startDate, endDate }) => {
        this.setState({ startDate, endDate });
    }

    render() {
        
        return (
            <BlockUi tag="div" blocking={this.state.block}>
            <Row>
                <Col className="col-2 pr-1">
                    <PaymentManagementMenu
                        toggleMenu={this.toggleMenu}
                        activeTab={this.state.activeTab}
                    />
                </Col>
                <Col className="col-10">
                    <TabContent activeTab={this.state.activeTab} className="h-100">
                        <TabPane tabId='Charges' className="border-0 my-0 p-0 h-100">
                            {this.state.activeTab === 'Charges' &&
                                <Shift4Charges
                                    startDate={this.state.startDate}
                                    endDate={this.state.endDate}
                                    handleDates={this.handleDates}
                                    chargeStatus={this.state.chargeStatus}
                                />
                            }
                        </TabPane>
                        <TabPane tabId='Customers' className="border-0 my-0 p-0 h-100">
                            {this.state.activeTab === 'Customers' &&
                                <Shift4Customers
                                    startDate={this.state.startDate}
                                    endDate={this.state.endDate}
                                    handleDates={this.handleDates}
                                    chargeStatus={this.state.chargeStatus}
                                />
                        }
                        </TabPane>
                        <TabPane tabId='Events' className="border-0 my-0 p-0 h-100">
                            {this.state.activeTab === 'Events' &&
                                <Shift4Events
                                    startDate={this.state.startDate}
                                    endDate={this.state.endDate}
                                    handleDates={this.handleDates}
                                />
                            }
                        </TabPane>
                        <TabPane tabId='Payouts' className="border-0 my-0 p-0 h-100">
                            {this.state.activeTab === 'Payouts' &&
                                <Shift4Payouts
                                    startDate={this.state.startDate}
                                    endDate={this.state.endDate}
                                    handleDates={this.handleDates}
                                />
                            }
                        </TabPane>

                        <TabPane tabId='PaymentLinks' className="border-0 my-0 p-0 h-100">
                            {this.state.activeTab === 'PaymentLinks' &&
                                <Shift4PaymentLinks
                                    startDate={this.state.startDate}
                                    endDate={this.state.endDate}
                                    handleDates={this.handleDates}
                                />
                            }
                        </TabPane>
                    </TabContent>
                </Col>
            </Row>
            </BlockUi>
        )
    }
}

export default injectIntl(PaymentManagement);